import { createRoot, hydrateRoot } from "react-dom/client";
import { preloadRoute } from "./app/App";
import { isLanding, splitLocale } from "./app/publicRoutes";
import { Root } from "./app/Root";
import { bootTheme } from "./app/theme";
import { CATALOG_KEY } from "./features/site/configurator/useConfigurator";
import { queryClient } from "./lib/session";
import "./styles.css";

bootTheme();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing in index.html");

/**
 * A public page arrives prerendered (ADR-0061, in its language: ADR-0062): #root holds its HTML and names its URL in
 * data-prerendered, and the catalog it was rendered with comes along as JSON. That page is hydrated once its code is
 * loaded, so React adopts the HTML instead of painting it again. Any other page (an app path served the SPA shell, the
 * 404 page) renders afresh.
 */
const page = splitLocale(root.dataset.prerendered ?? "");
const here = splitLocale(location.pathname);
const prerendered = page.lang !== null && page.lang === here.lang && (page.path === here.path || (isLanding(page.path) && isLanding(here.path)));

function render() {
  root?.replaceChildren();
  if (root) createRoot(root).render(<Root client={queryClient} />);
}

if (prerendered) {
  const catalog = document.getElementById("prerender-catalog")?.textContent;
  // Stale from the start: the live catalog is fetched right after hydration and replaces the build's copy.
  if (catalog) queryClient.setQueryData(CATALOG_KEY, JSON.parse(catalog), { updatedAt: 0 });
  preloadRoute(here.path).then(() => hydrateRoot(root, <Root client={queryClient} />), render);
} else {
  render();
}
